import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import SideMsg from '#/modules/commonComponents/SideMsg';
import RepairReportCommandBar from '#/modules/crmMgmt/aftersales/repairReport/components/RepairReportCommandBar';
import {
  repairReportSideMsgDetailBlock,
  repairReportSideMsgStatusBlock,
} from '#/modules/crmMgmt/aftersales/repairReport/data/repairReportSideMsgConfig';

/** 側欄對齊物料列表：狀態 → 操作（詳情＋單據操作）→ 明細。 */
const RepairReportSideMsg = ({ displayData, onRefetch }) => {
  const id = displayData?.id;

  const blocks = [
    repairReportSideMsgStatusBlock,
    {
      condition: () => Boolean(id),
      fields: [
        {
          key: 'actions',
          label: '操作',
          render: () => (
            <div className="side_msg-row">
              <h3>操作</h3>
              <div className="flex flex-wrap items-center gap-2">
                <Button type="button" variant="outline" asChild>
                  <Link to={ROUTES.repairReportDetail(id)}>詳情</Link>
                </Button>
                <RepairReportCommandBar
                  key={`${id}-${displayData?.record?.updatedAt ?? ''}`}
                  detail={displayData}
                  onRefetch={onRefetch}
                />
              </div>
            </div>
          ),
        },
      ],
    },
    repairReportSideMsgDetailBlock,
  ];

  return (
    <SideMsg
      title="維修報告"
      titleValue="repairReportNo"
      displayData={displayData}
      blocks={blocks}
    />
  );
};

RepairReportSideMsg.propTypes = {
  displayData: PropTypes.object,
  onRefetch: PropTypes.func,
};

export default RepairReportSideMsg;
